// src/json/overlayData.json
export const overlaySectionHighRiseMidRiseProjects = {
    imageUrl: "/assets/imgs/services/4HighRiseMidRiseProjects/overlaySection/fondo.jpg",
    text: "The best Building Envelope Renewal /",
    highlight: "High-Rise Painting & Restoration services."
};
